import React from "react";
import arrow from "../assets/fleche.svg";
import pokeball from "../assets/pokeball4.png";
import { Link } from "react-router-dom";

function SelectionArrow({ pokemonId }) {
  return (
    <div className="flex items-center justify-center">
      {pokemonId !== 1 && (
        <Link to={`/pokemon/${pokemonId - 1}`}>
          <img
            src={arrow}
            alt="arrow"
            className="cursor-pointer arrowLeft fill-slate-50 max-h-12 rotate-180 ease-in-out duration-0 hover:duration-300 hover:scale-110"
          />
        </Link>
      )}
      <Link to="/">
        <img
          src={pokeball}
          alt="arrow"
          className="hover:brightness-150 cursor-pointer pokeball mx-3"
        />
      </Link>
      {pokemonId !== 898 && (
        <Link to={`/pokemon/${pokemonId + 1}`}>
          <img
            src={arrow}
            alt="arrow"
            className="cursor-pointer arrowRight  max-h-12 ease-in-out	duration-0 hover:duration-300 hover:scale-110"
          />
        </Link>
      )}
    </div>
  );
}

export default SelectionArrow;
